__turbopack_context__.v({
  "amount": "plan-card-module-scss-module__9upVIW__amount",
  "billing": "plan-card-module-scss-module__9upVIW__billing",
  "body": "plan-card-module-scss-module__9upVIW__body",
  "description": "plan-card-module-scss-module__9upVIW__description",
  "disabled": "plan-card-module-scss-module__9upVIW__disabled",
  "feature": "plan-card-module-scss-module__9upVIW__feature",
  "hidden": "plan-card-module-scss-module__9upVIW__hidden",
  "inner": "plan-card-module-scss-module__9upVIW__inner",
  "open": "plan-card-module-scss-module__9upVIW__open",
  "original_price": "plan-card-module-scss-module__9upVIW__original_price",
  "period": "plan-card-module-scss-module__9upVIW__period",
  "placeholder": "plan-card-module-scss-module__9upVIW__placeholder",
  "popular": "plan-card-module-scss-module__9upVIW__popular",
  "popular_badge": "plan-card-module-scss-module__9upVIW__popular_badge",
  "price": "plan-card-module-scss-module__9upVIW__price",
  "red_mark": "plan-card-module-scss-module__9upVIW__red_mark",
  "root": "plan-card-module-scss-module__9upVIW__root",
  "selected": "plan-card-module-scss-module__9upVIW__selected",
  "separator": "plan-card-module-scss-module__9upVIW__separator",
  "standalone": "plan-card-module-scss-module__9upVIW__standalone",
  "title": "plan-card-module-scss-module__9upVIW__title",
  "toggle": "plan-card-module-scss-module__9upVIW__toggle",
});
